import type React from "react"

import { leadStatusStyles } from "../../Lead/constants/lead-statuses"
import { PROJECT_STATUSES_MAP } from "../../Projects/constants/project-statuses"
import type { MapLayer } from "../redux/global-map.types"

// Neutral, on-brand fallback for a status label neither canonical palette
// recognizes — needed for Subcontractor/Appointment rows, whose statuses
// come from an entirely different vocabulary
// (apps.subcontractor.models.Subcontractor.Status /
// apps.calendars.models.EventStatus) that was never meant to be covered by
// the Lead/Project palettes. Matches the neutral gray this pill used
// unconditionally before this fix, so an unrecognized label still reads as
// "no strong signal" rather than an error state.
const GLOBAL_MAP_STATUS_FALLBACK_STYLE: React.CSSProperties = {
  color: "#1D4ED8",
  backgroundColor: "#EFF6FF",
  borderColor: "#BFDBFE"
}

/**
 * Resolves a Global Map status pill's color from the same two canonical,
 * already-shipped palettes the rest of the app uses for these entities —
 * `PROJECT_STATUSES_MAP` for a project, `leadStatusStyles` for a lead —
 * rather than a Global Map-specific color scheme. Falls back to a defined
 * neutral style for any label neither map recognizes.
 */
export function globalMapStatusStyle(
  entityType: MapLayer,
  statusLabel: string
): React.CSSProperties {
  if (entityType === "project") {
    return (
      PROJECT_STATUSES_MAP[statusLabel]?.style ??
      GLOBAL_MAP_STATUS_FALLBACK_STYLE
    )
  }
  return leadStatusStyles[statusLabel] ?? GLOBAL_MAP_STATUS_FALLBACK_STYLE
}
